import { http } from '@pendo/http';

export function sendAccessRequest (entityType, entityId, permission) {
    return http.post(`/api/s/_SID_/accessRequest/${entityType}/${entityId}`, { permission }).then(({ data }) => data);
}

export function fetchUserAccessRequest (entityType, entityId) {
    return http.get(`/api/s/_SID_/accessRequest/${entityType}/${entityId}`).then((response) => {
        if (!response) {
            return {};
        }

        return response.data;
    });
}

export function cancelAccessRequest (requestId, entityType, decision) {
    return http.post(`/api/s/_SID_/accessRequest/${requestId}/${entityType}`, { decision });
}

export function processAccessRequestDecision (requestId, decision, overridePermission = '') {
    const payload = { decision };

    if (decision === 'approve' && overridePermission) {
        payload.override = overridePermission;
    }

    return http.post(`/api/s/_SID_/accessRequest/${requestId}/dashboard`, payload);
}

export function getPermissionLabel (permission) {
    return permission === 'edit' ? 'editor' : 'viewer';
}

export function formatUserName ({ first, last, username }) {
    if (first && last) {
        return `${first} ${last}`;
    }

    return username;
}
